<template>
  <div
    class="filter-field-control"
    :class="{ 'filter-field-control--compact': compact }"
  >
    <b-form-group
      v-if="field.field !== 'actions' && field.type !== 'date'"
      :label="field.label"
      :label-for="inputId"
      :class="{ 'mb-0': compact }"
    >
      <b-input-group v-if="field.type !== 'select'">
        <b-form-select
          v-if="field.filterOperators"
          class="filter-field-control__operator"
          :value="operatorValue"
          :options="field.filterOperators"
          :aria-label="`Tipo de comparação para ${field.label}`"
          @input="$emit('operator-input', $event)"
        />
        <b-form-input
          :id="inputId"
          :name="field.label"
          :value="value"
          :type="field.type"
          @keydown.enter="$emit('enter')"
          @input="$emit('input', $event)"
        />
      </b-input-group>

      <b-form-select
        v-else
        :id="inputId"
        :value="value"
        :key="renderKey"
        :options="field.options"
        @input="$emit('input', $event)"
      />
    </b-form-group>

    <DatePickerInput
      v-else-if="field.type === 'date'"
      :label="field.label"
      :value="dateValues"
      :field="field.field"
      mode="range"
      @valueUpdated="$emit('date-input', $event)"
    />
  </div>
</template>

<script>
import DatePickerInput from "@/components/DatePickerInput/index.vue";

export default {
  name: "FilterFieldControl",
  components: {
    DatePickerInput,
  },
  props: {
    compact: {
      type: Boolean,
      default: false,
    },
    dateValues: {
      type: Object,
      default: () => ({}),
    },
    field: {
      type: Object,
      required: true,
    },
    operatorValue: {
      default: null,
    },
    renderKey: {
      type: Number,
      default: 0,
    },
    value: {
      default: null,
    },
  },
  computed: {
    inputId() {
      return `filter-${this.field.field}`;
    },
  },
};
</script>

<style scoped>
.filter-field-control__operator {
  flex: 0 0 145px !important;
  max-width: 145px;
}

.filter-field-control--compact ::v-deep label {
  color: #4b5068;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 6px;
}

.filter-field-control--compact ::v-deep .form-control,
.filter-field-control--compact ::v-deep .custom-select {
  height: 38px;
}

@media (max-width: 575px) {
  .filter-field-control__operator {
    flex-basis: 120px !important;
    max-width: 120px;
  }
}
</style>
